<script setup>
import { ref } from 'vue'
import Users from '@/components/CompanyUsers.vue'
import Accounts from '@/components/Accounts.vue'

const selectedTab = ref(0)
</script>

<template>
  <v-container>
    <v-tabs v-model="selectedTab" vertical>
      <v-tab>Users</v-tab>
      <v-tab>Accounts</v-tab>
      <v-tab>Products</v-tab>
      <v-tab>Overview</v-tab>
    </v-tabs>
    <v-tab-item v-if="selectedTab === 0">
      <v-card class="pa-4" flat>
        <Users />
      </v-card>
    </v-tab-item>
    <v-tab-item v-if="selectedTab === 1">
      <v-card class="pa-4" flat>
        <Accounts />
      </v-card>
    </v-tab-item>
    <v-tab-item v-if="selectedTab === 2">
      <v-card class="pa-4" flat>
        <v-card-title>Products</v-card-title>
        <v-card-text>
          <p>This is the Products tab content.</p>
        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item v-if="selectedTab === 3">
      <v-card class="pa-4" flat>
        <v-card-title>Overview</v-card-title>
        <v-card-text>
          <p>This is the Overview tab content.</p>
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-container>
</template>
